import { useMemo } from 'react';
import { StyledSingleSelectOption } from '../../../Dropdown/SingleSelect';
import useNavigateSuggestions from './utils/useNavigateSuggestions';
import emojiData from './utils/emojiData';

interface IProps {
  term: string;
  onSelect: (value: string) => void;
}

type IEmojiListOption = {
  emoji: string;
  label: string;
};

const EmojiSuggestions = ({ term, onSelect }: IProps) => {
  const emojiList = useMemo<Array<IEmojiListOption>>(() => {
    if (!term.length) {
      return [];
    }
    const lowerCasedTerm = term.toLowerCase();

    return emojiData.reduce<Array<IEmojiListOption>>(
      (acc, { label, unicode }) => {
        // Show max 10 results
        if (acc.length === 10) {
          return acc;
        }

        const includeEmoji = label.toLowerCase().includes(lowerCasedTerm);

        if (includeEmoji) {
          acc.push({
            emoji: unicode,
            label,
          });
        }

        return acc;
      },
      [],
    );
  }, [term]);

  const handleSelectFromKeyboard = (index: number) => {
    if (emojiList[index]) {
      onSelect(emojiList[index].emoji);
    }
  };

  const activeIndex = useNavigateSuggestions(
    emojiList.length,
    handleSelectFromKeyboard,
  );

  return (
    <>
      {emojiList.map((emojiData, index) => (
        <StyledSingleSelectOption
          key={emojiData.emoji}
          onClick={() => onSelect(emojiData.emoji)}
          isFocused={activeIndex === index}
        >
          <span>{emojiData.emoji}</span>
          <span>{emojiData.label}</span>
        </StyledSingleSelectOption>
      ))}
    </>
  );
};

export default EmojiSuggestions;
